import { InventoryReportStatusEnum, Report } from 'types/report';

export type EditHarvestSummaryModalProps = {};

export type UpdateStatusProp = (payload: {
  reportId: string;
  status: InventoryReportStatusEnum;
  cokeAdjustment?: number;
  feeAdjustment?: number;
  feeAdjustments?: Array<{ type: string; amount: number }>;
  invoiceNotes?: string;
  notes?: string;
  isSentToClient?: boolean;
}) => void;

export type EditHarvestSummaryModalViewProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (values: any) => void;
  isLoading: boolean;
  report: Report | null;
  onRefresh: () => void;
  onDelete: () => void;
  updateStatus: UpdateStatusProp;
};

export type RefType = {
  onOpen: (_report: Report | null) => void;
};

export enum Tabs {
  ALL = 0,
  IN_REVIEW = 1,
  READY_FOR_IMPACT = 2,
  READY_FOR_INVOICE = 3,
  DONE = 4,
  ARCHIVE = 5,
}

export enum HarvestSummaryModalTabs {
  SKU_DETAIL = 0,
  INVOICING = 1,
  ACTIVITY_HISTORY = 2,
}
